import {
  assessmentEvidenceApprove,
  assessmentPlanSectionUrl,
  getAssessmentPlansPushToCanvasUrl,
  getAssessmentPlansUrl,
  getAssessmentStudentsEvidenceUrl,
  getAssessmentUrl,
  getResultsUrl,
  getSubmitPurlResultsUrl,
  sectionUrl,
  updateAssessmentEvidenceApprover,
  updateAssessmentPlanReviewersUrl,
  updateAssessmentPlanSequencesUrl,
  updateAssessmentUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class AssessmentPlanService {
  static getAssessmentPlans = () => {
    return getRequest(getAssessmentPlansUrl());
  };

  static getLightAssessmentPlans = () => {
    return getRequest(getAssessmentPlansUrl() + "/light");
  };

  static getAssessmentPlansBySubjects = (subjectIds) => {
    const params = { subjects: subjectIds };
    return getRequest(getAssessmentPlansUrl() + "/subject", params);
  };

  static getAssessmentPlanById = (planId, signal = null) => {
    return getRequest(
      getAssessmentPlansUrl() + "/" + planId,
      {},
      false,
      signal
    );
  };

  static createAssessmentPlan = (assessmentPlan) => {
    return postRequest(getAssessmentPlansUrl(), assessmentPlan);
  };

  static submitPurlResults = (purlResults) => {
    return postRequest(getSubmitPurlResultsUrl(), purlResults);
  };

  static createAssessment = (assessment) => {
    return postRequest(getAssessmentUrl(), assessment);
  };

  static getAvgJaScores = (assignmentId) => {
    return getRequest(getResultsUrl() + "/avg/" + assignmentId);
  };

  static updateAssessment = (assessment) => {
    return putRequest(
      updateAssessmentUrl(assessment.assessment.id),
      assessment
    );
  };

  static deleteAssessment = (assessmentId) => {
    return deleteRequest(getAssessmentUrl() + "/" + assessmentId);
  };

  static getAssessmentById = (assessmentId) => {
    return getRequest(getAssessmentUrl() + "/" + assessmentId);
  };

  static deletePlan = (planId) => {
    return deleteRequest(getAssessmentPlansUrl() + "/" + planId);
  };

  static sendPlanToCanvas = (planId) => {
    return postRequest(getAssessmentPlansPushToCanvasUrl(planId));
  };

  static getAssessmentForPurl = (assessmentId, termId) => {
    return getRequest(getAssessmentUrl() + "/" + assessmentId + "/" + termId);
  };

  static updateAssessmentPlanReviewers = (approvers, reviewers, planId) => {
    const payload = { approvers: approvers, reviewers: reviewers };
    return putRequest(updateAssessmentPlanReviewersUrl(planId), payload);
  };

  static getAssessmentStudentsEvidence = (assessmentId, termIds) => {
    const params = { termIds: termIds };
    return getRequest(getAssessmentStudentsEvidenceUrl(assessmentId), params);
  };

  static verifyPlanMappings = (
    outcomeId,
    courseCodes,
    levelIds,
    programIds,
    assessmentType
  ) => {
    const params = {};
    if (outcomeId) {
      params.loIds = outcomeId;
    }
    if (courseCodes) {
      params.courseCodes = courseCodes;
    }
    if (levelIds) {
      params.levelIds = levelIds;
    }
    if (programIds.length > 0) {
      params.programs = programIds;
    }
    if (assessmentType) {
      params.assessment_type = assessmentType;
    }
    return getRequest(
      getAssessmentPlansUrl() + "/verify-existing-mappings",
      params
    );
  };

  static getPlansForSection = (sectionId, termId) => {
    return getRequest(
      getAssessmentPlansUrl() + "/section/" + sectionId + "/" + termId
    );
  };

  static updateAssessmentEvidenceApprover = (
    approver,
    planId,
    assessmentId
  ) => {
    const params = { approverEmail: approver };

    return putRequest(
      updateAssessmentEvidenceApprover(planId, assessmentId),
      params,
      true,
      true
    );
  };

  static approveAssessmentEvidence = (planId, assessmentId) => {
    return putRequest(assessmentEvidenceApprove(planId, assessmentId));
  };

  static updateAssessmentPlanSequences = (planId, sequenceList) => {
    const params = { sequenceMap: sequenceList };
    return putRequest(updateAssessmentPlanSequencesUrl(planId), params);
  };

  static createAssessmentPlanSection = (
    planId,
    section,
    insightsTermId = null
  ) => {
    const params = { assessmentSection: section, insightsTermId };
    return postRequest(sectionUrl(planId), params);
  };

  static updateAssessmentPlanSection = (
    sectionId,
    name,
    description,
    approvers,
    reviewers,
    insightsTermId = null,
    planId = null
  ) => {
    const params = {
      assessmentSection: {
        name: name,
        description: description,
        approvers: approvers,
        reviewers: reviewers,
      },
      insightsTermId,
      planId,
    };
    return putRequest(assessmentPlanSectionUrl(sectionId), params);
  };

  static deleteAssessmentPlanSection = (sectionId) => {
    return deleteRequest(assessmentPlanSectionUrl(sectionId));
  };

  static updateAssessmentPlan = (
    planId,
    {
      approvers,
      reviewers,
      purlReviewers,
      sequenceMap,
      includeGoalsObjs,
      notifyPriorTermEndDays,
      notifyPastTermEndDays,
      notifyBeforeMessage,
      notifyOnEndMessage,
      notifyAfterMessage,
      insightsTermId,
    }
  ) => {
    const params = {
      approvers,
      reviewers,
      purlReviewers,
      sequenceMap,
      includeGoalsObjs,
      notifyPriorTermEndDays,
      notifyPastTermEndDays,
      notifyBeforeMessage,
      notifyOnEndMessage,
      notifyAfterMessage,
      insightsTermId,
    };
    return putRequest(getAssessmentPlansUrl() + "/" + planId, params);
  };
}
